module.exports = __webpack_public_path__ + "img/精致面具--个性定制.55f0ffc9.png";